import { LotteryTask } from "../../../core/_shared/models/task.model";
import { DbListBase } from "./db-list-base";
import { DbObjectBase } from "./db-object-base";
import { ICollectionReference } from '../database-cast/IDatabase';


export class DbCustomerLotteryBetTask extends DbObjectBase<LotteryTask>
{
    constructor(id: string, colllection: ICollectionReference)
    {
        super(id,colllection);
    }
}

export class DbCustomerLotteryBetTasks extends DbListBase<LotteryTask> {
  
  public   getTask(id: string): DbCustomerLotteryBetTask {
   
    return new DbCustomerLotteryBetTask(id,this._collection);
  }


    constructor(collection: ICollectionReference) {
        super(collection);

    }


    public AddTask(task: LotteryTask): Promise<LotteryTask> {

        let promise = new Promise<LotteryTask>((resolve, reject) => {


            let objTask =JSON.parse( JSON.stringify(task));

   
            if(task.id == null || task.id == "")
            {

            this._collection.add(objTask)
                .then(docReference => {
             
                    task.id = docReference.id;
                    resolve(task);
                }).
                catch(error => {

             
                    reject(error);

                });
            }
            else
            {
                this._collection.doc(task.id).set(objTask)
                .then(docReference => {
             
                   // task.id = docReference.id;
                    resolve(task);
                }).
                catch(error => {

             
                    reject(error);

                });
            }
        });


        return promise;
    }


}